var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3869 11.2651C12.8523 11.2109 13.3242 11.3035 13.7218 11.5272L27.279 18.4454L23.848 21.5627L12.3869 11.2651ZM11.3441 12.2013C11.2787 12.4051 11.2471 12.6164 11.2502 12.8285V32.1693C11.2471 32.3813 11.2787 32.5927 11.3441 32.7965L22.8156 22.4989L11.3441 12.2013ZM23.8584 23.435L12.3869 33.7326C12.8525 33.7918 13.3263 33.6987 13.7218 33.4705L27.279 26.5524L23.8584 23.435ZM32.7436 21.2444L28.6348 19.1475L24.8804 22.4989L28.6243 25.8596L32.7332 23.7627C34.0889 23.0699 34.0889 21.9278 32.7332 21.2351L32.7436 21.2444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/PlayStoreIcon.28e26ab519a9d4f1f95693084da5613f.svg";
export { ForwardRef as ReactComponent };